import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Menu from '../Menu';
import { active } from './styles.css';
import FeatureEnabled from '../FeatureEnabled';
import FeatureDisabled from '../FeatureDisabled';
import { withCommunityProfileIdQuery } from '../../utils/community';
import { withEnabledFeatures } from '../../utils/features';
import { COMMUNITY_SERVERLESS, DISABLE_LEGACY_COMMUNITY } from '../../containers/Authorization/constants';

const canAccessLegacyCommunity = ({ enabledFeatures, communityProfile }) => {
  const isServerlessCommunityOn = (enabledFeatures || []).includes(COMMUNITY_SERVERLESS);
  const communityProfileId = get(communityProfile, 'viewer.profile.communityId', '');
  const communityIdMatchesUUID = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/.test(communityProfileId);
  const isCommunityProfileServerless = !communityProfileId || communityIdMatchesUUID;
  return !isServerlessCommunityOn || !isCommunityProfileServerless;
};

export const MainMenu = ({ idPrefix, onClick, enabledFeatures, communityProfile }) => (
  <div>
    <Menu as="dl" styleName="navHeaderUpdatesMenu" vertical inverted size="huge" onClick={onClick}>
      <Menu.Header as="dt" styleName="menu-sub-header nav18updates">
        <FormattedMessage id="app.mainMenu.subtitle.awareness" defaultMessage="Awareness" />
      </Menu.Header>
      {
          !communityProfile?.viewer?.isNavianceLogin && (
            <FeatureEnabled allOf={COMMUNITY_SERVERLESS}>
              <Menu.Item as="dt" link styleName="menu-item">
                <NavLink
                  aria-label="Community Serverless"
                  to="/counselorcommunity/"
                  id={`js-${idPrefix}-home-menu-link`}
                  data-cy="serverless-community-link"
                  styleName="popup-menu-link"
                  activeClassName={active}
                >
                  <FormattedMessage id="app.mainMenu.link.communityserverless" defaultMessage="Counselor Community" />
                </NavLink>
              </Menu.Item>
            </FeatureEnabled>
          )
        }
      {canAccessLegacyCommunity({ enabledFeatures, communityProfile }) && (
      <FeatureDisabled anyOf={DISABLE_LEGACY_COMMUNITY}>
        <Menu.Item as="dt" link styleName="menu-item">
          <NavLink
            aria-label="Community"
            to="/community/"
            id={`js-${idPrefix}-home-menu-link`}
            data-cy="legacy-community-link"
            styleName="popup-menu-link"
            activeClassName={active}
          >
            <FormattedMessage id="app.mainMenu.link.community" defaultMessage="Counselor Community" />
          </NavLink>
        </Menu.Item>
      </FeatureDisabled>
      )}
      {process.env.GRAPHIQL && (
      <Menu.Item as="dt" link styleName="menu-item">
        <NavLink
          to="/graphiql"
          id={`js-${idPrefix}-graphiql-menu-link`}
          styleName="popup-menu-link"
          activeClassName={active}
        >
          <FormattedMessage id="app.mainMenu.link.graphiql" defaultMessage="GraphiQL" />
        </NavLink>
      </Menu.Item>
      )}
      <Menu.Header as="dt" styleName="menu-sub-header nav18updates">
        <FormattedMessage id="app.mainMenu.subtitle.presence" defaultMessage="Presence" />
      </Menu.Header>
      <Menu.Item as="dt" link styleName="menu-item">
        <NavLink
          aria-label="RepVisits"
          to="/rep-visits/calendar"
          id={`js-${idPrefix}-rep-visits-menu-link`}
          styleName="popup-menu-link"
          isActive={(match, location) => location.pathname.startsWith('/rep-visits/')}
          activeClassName={active}
        >
          <FormattedMessage id="app.mainMenu.link.repvisits" defaultMessage="RepVisits" />
        </NavLink>
      </Menu.Item>
    </Menu>
  </div>
);

MainMenu.propTypes = {
  onClick: PropTypes.func,
  idPrefix: PropTypes.string.isRequired,
  enabledFeatures: PropTypes.array,
  communityProfile: PropTypes.object,
};

export default withCommunityProfileIdQuery(withEnabledFeatures(MainMenu));
